import { RouteNames } from 'models/routes'
import React from 'react'
import { Route, Routes } from 'react-router-dom'

const routes = [
  {
    path: RouteNames.home,
    component: React.lazy(() => import('../pages/LlistatCopies'))
  },
  {
    path: RouteNames.novaCopia,
    component: React.lazy(() => import('../pages/NovaCopia'))
  },
  {
    path: RouteNames.novaPlantilla,
    component: React.lazy(() => import('../pages/NovaPlantilla'))
  },
  {
    path: RouteNames.llistatPlantilles,
    component: React.lazy(() => import('../pages/LlistatPlantilles'))
  },
  {
    path: RouteNames.editarPlantilla,
    component: React.lazy(() => import('../pages/EditarPlantilla'))
  },
  {
    path: RouteNames.llistatOrgans,
    component: React.lazy(() => import('../pages/LlistatOrgans'))
  },
  {
    path: RouteNames.sessioCopia,
    component: React.lazy(() => import('../pages/IFrameCopia'))
  },
  {
    path: RouteNames.copiaCallback,
    component: React.lazy(() => import('../pages/CopiaCallback'))
  },
  {
    path: '*',
    component: React.lazy(() => import('../pages/404'))
  }
]

const AppRoutes = () => {
  return (
    <Routes>
      {routes.map((route, i) => (
        <Route
          path={route.path}
          element={
            <React.Suspense>
              <route.component />
            </React.Suspense>
          }
          key={i}
        />
      ))}
    </Routes>
  )
}

export default AppRoutes
